import '../../App.css';
import React, { useContext } from "react";
import { ApiContext } from '../../context/ApiContext';
import { IoIosWarning } from "react-icons/io";
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';

function ModalConcluirDemanda() {

    const { setConcluirDemandaModal, ConcluirDemanda } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    return (
        <div className="modal-novo">
            <div className="modal-interno-delete">
                <div className="modal-content-delete">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '20px', padding: '16px' }} className='border-bottom'>
                        <div>
                            <IoIosWarning style={{ color: '#FACC15', marginRight: '5px' }} /> Concluir iniciativa
                        </div>
                        <button className='btn-fechar' onClick={() => setConcluirDemandaModal(false)}>
                            <FaTimes />
                        </button>
                    </div>
                    <div style={{ padding: '16px' }} className='border-bottom'>
                        Tem certeza que deseja concluir essa iniciativa?
                    </div>
                    <div className="content-buttons">
                        <button type="submit" className="btn-dash btn-ver" style={btnVer} onClick={() => setConcluirDemandaModal(false)}>Cancelar</button>
                        <button type="submit" className="btn-dash btn-criar" style={btnCriar} onClick={() => ConcluirDemanda()}>Salvar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalConcluirDemanda